import { logger, settings as settingsStore } from '../stores'
import { checkForNewParcels, deleteExpiredMediaParcelsOnInboxServer } from './receive-parcels.js'
import { updateProfileBackup } from './profile-backup.js'
import { parseIsoString } from './dume.js'
import { contactsDeferredUpdate, updateNotificationContacts } from './contacts-deferred-update.js'
import { reRegisterIfNeeded } from './push-notifications.js'

export async function backgroundSync(settings) {
  if (!settings.inboxServerHost || settings.displayName == null) {
    return
  }

  try {
    console.log('Background sync...')

    await deleteExpiredMediaParcelsOnInboxServer()
    await checkForNewParcels()

    if (settings.contactsChanged === true) {
      logger.log('deferred contacts update...')
      contactsDeferredUpdate()
    } else {
      updateNotificationContacts()
    }

    const oneHour = 60 * 60 * 1000
    if (parseIsoString(settings.lastProfileBackup) < (Date.now() - oneHour)) {
      updateProfileBackup(settings) // no await wanted
    }

    const oneDay = 24 * 60 * 60 * 1000
    if (parseIsoString(settings.lastPushRegistration) < (Date.now() - oneDay)) {
      reRegisterIfNeeded(settings.inboxServerHost).then(() => {
        settingsStore.set('lastPushRegistration', new Date().toISOString())
      }).catch(logger.error)
    }
  } catch (error) {
    logger.error(error)
  }
}
